import React from 'react';
import { makeStyles} from '@material-ui/core/styles';
import cx from 'clsx';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import IconButton from '@material-ui/core/IconButton';
import FavoriteBorderRounded from '@material-ui/icons/FavoriteBorderRounded';
import Share from '@material-ui/icons/Share';
import { useSoftRiseShadowStyles } from '@mui-treasury/styles/shadow/softRise';
import { useN01TextInfoContentStyles } from '@mui-treasury/styles/textInfoContent/n01';
import TextInfoContent from '@mui-treasury/components/content/textInfo';
import image from '../../public/faces/5.jpg';
import {AuthData} from '../Services/Authdata';

const useStyles1 = makeStyles(() => ({
    root: {
      maxWidth: 304,
      margin: 'auto',
    },
    content: {
      padding: 24,
    },
    avatar: {
        position:'absolute',
        marginTop:'-3%',
        marginLeft:'12%',
      width: 50,
      height: 50,
      border: '2px solid #fff',
      margin: '-48px 32px 0 auto',
      '& > img': {
        margin: 0,
      },
    },
  }));
export default function Profile() {
  const cardStyles = useStyles1();
  const shadowStyles = useSoftRiseShadowStyles();
  const textCardContentStyles = useN01TextInfoContentStyles();
  
  return (
    <div>
        <Avatar className={cardStyles.avatar} src={image} size="md" alt={AuthData().name}/>
       <Card className={cx(cardStyles.root, shadowStyles.root)}>
       
        {/* <CardMedia
            classes={mediaStyles}
            image={
            'https://images.unsplash.com/photo-1517147177326-b37599372b73?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2229&q=80'
            }
        /> */}
      
      <CardContent className={cardStyles.content}>
        <TextInfoContent
          classes={textCardContentStyles}
          heading={AuthData().name}
          body={
            'Snow storm coming in Sommaroy island, Arctic Norway. This is something that you definitely wanna see in your life.'
          }
        />
      </CardContent>
      <Box px={2} pb={2} mt={-1}>
        <IconButton>
          <Share />
        </IconButton>
        <IconButton>
          <FavoriteBorderRounded />
        </IconButton>
      </Box>
    </Card>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/Pages/Profile.js